import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "star", "input", "label"]
  static values = {
    size: { type: String, default: "large" }
  }

  connect() {
    this.currentRating = parseInt(this.inputTarget.value) || 0
    this.updateStars()
  }

  setRating(event) {
    event.preventDefault()
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.currentRating = rating
    this.inputTarget.value = rating
    this.updateStars()
    this.updateLabel()
  }

  updateStars() {
    this.starTargets.forEach((star, index) => {
      if (index < this.currentRating) {
        star.classList.remove('text-gray-300')
        star.classList.add('text-yellow-400')
      } else {
        star.classList.remove('text-yellow-400')
        star.classList.add('text-gray-300')
      }
    })
  }

  updateLabel() {
    if (!this.hasLabelTarget) return

    const labels = {
      1: "Poor",
      2: "Fair",
      3: "Good",
      4: "Very Good",
      5: "Excellent"
    }

    this.labelTarget.textContent = labels[this.currentRating] || "Select a rating"
  }

  // Hover effects
  mouseEnter(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.starTargets.forEach((star, index) => {
      if (index < rating) {
        star.classList.remove('text-gray-300')
        star.classList.add('text-yellow-400')
      } else {
        star.classList.remove('text-yellow-400')
        star.classList.add('text-gray-300')
      }
    })
  }

  mouseLeave() {
    this.updateStars()
  }
}
